import type { Ref } from 'vue'
import { useRoute } from '#vue-router'
import { getFooterTdk } from '~/server/newhouse'
import type { TdkRequestParams } from '~/server/newhouse/interface'
import routerList from '~/common/routers/routerList'

export default async function useMeta(paramsRef: Ref<TdkRequestParams>) {
  // 获取路由表中页面 pageTypeId参数
  const route = useRoute()
  // 获取TDK数据
  const { data: tdkData, refresh } = await useAsyncData(async () => {
    const { pageTypeId, expandData } = routerList.find(i => i.name === route.name) || {}
    let exP = ''
    // 针对 带expandData的路由特殊处理
    if (expandData) {
      exP = `${combinationCondition(route?.params?.filterIndex || route?.params?.condition)}`
      exP += `_${conditionStringify(expandData)}`
    }
    const paramsReq = Object.assign({}, {
      pageTypeId,
    }, paramsRef.value, {
      p: exP || paramsRef?.value?.p,
    })
    const { code, dataBody = {} as any } = await getFooterTdk(paramsReq)
    if (code === 0)
      return dataBody || {}
  })
  // todo 此处使用useHead会报错 - 待后续研究
  // 设置页面TDK参数
  // useHead({
  //   title: tdkData.value?.title ?? '房产超市',
  //   meta: [
  //     { name: 'keywords', content: tdkData.value?.keywords ?? '' },
  //     { name: 'description', content: tdkData.value?.description ?? '' },
  //   ],
  // })
  return { tdkData, refresh }
}
